var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 84,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.497,
    height: 70.259,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.041)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5,57.074a35.249,35.249,0,1,1-35.248-35.13A35.189,35.189,0,0,1,70.5,57.074",
    transform: "translate(0 -21.944)",
    fill: "#edf1fc"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.452,16.081a1.451,1.451,0,0,1-1.276-.756l-4.92-9.033a1.449,1.449,0,0,1,2.549-1.379l4.92,9.033a1.447,1.447,0,0,1-1.273,2.135",
    transform: "translate(-71.71 -3.012)",
    fill: "#195ace"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.269,9.565A1.462,1.462,0,0,1,160,9.54a1.446,1.446,0,0,1-1.159-1.686l1.251-6.674a1.45,1.45,0,0,1,2.852.531l-1.251,6.674a1.449,1.449,0,0,1-1.424,1.18",
    transform: "translate(-114.944 0.001)",
    fill: "#195ace"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.626,60.887a1.453,1.453,0,0,1-.632-.145l-7.421-3.589a1.446,1.446,0,1,1,1.266-2.6l7.421,3.589a1.445,1.445,0,0,1-.634,2.746",
    transform: "translate(-39.63 -39.428)",
    fill: "#195ace"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.877,138.3a27.512,27.512,0,1,0-10.442,7.591,23.674,23.674,0,0,0,11.729,5.573s-3.626-9.232-1.287-13.164",
    transform: "translate(-78.428 -67.467)",
    fill: "#195ace"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.16,185.723a2.685,2.685,0,1,1-2.685-2.676,2.68,2.68,0,0,1,2.685,2.676",
    transform: "translate(-115.649 -132.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68,185.723A2.685,2.685,0,1,1,201,183.047a2.68,2.68,0,0,1,2.685,2.676",
    transform: "translate(-143.528 -132.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.2,185.723a2.685,2.685,0,1,1-2.685-2.676,2.68,2.68,0,0,1,2.685,2.676",
    transform: "translate(-171.409 -132.651)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.e2b2a8ccbe5cd9ba40c863481a024aa6.svg";
export { ForwardRef as ReactComponent };